import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Responsive, useResponsive } from '@common-fe/common-fe';

import { StepperSidebar } from '@/components';
import { Topbar } from '@/modules/core/components';

interface Props {
  children?: React.ReactNode;
  currentStep: number;
}
const SelfDIrectedInvestMoreWrapper: React.FC<Props> = ({ children, currentStep }) => {
  const { t } = useTranslation();
  const { isMobile } = useResponsive();
  const OPTIONS = useMemo(() => [{ key: 1, value: t('Invest More') }], [t]);
  return (
    <div>
      <Box direction="row" flex="grow" fill data-testid="StartInvesting-wrapper">
        <Responsive sizes={[Responsive.Tablet, Responsive.Desktop]}>
          <StepperSidebar title={t('Invest More')} options={OPTIONS} step={currentStep} />
        </Responsive>

        <Box
          fill
          style={{
            display: 'block',
            position: 'relative',
          }}
        >
          <Responsive sizes={[Responsive.Tablet, Responsive.Desktop]}>
            <Box direction="row" justify="center">
              <Box flex="grow" pad={{ horizontal: '40px' }} margin={{ bottom: 'l' }}>
                <Topbar />
              </Box>
            </Box>
          </Responsive>
          <Box
            direction="column"
            margin={isMobile ? {} : { horizontal: 'spacing32' }}
            pad={isMobile ? {} : { horizontal: 'spacing8' }}
            style={{ position: 'relative' }}
          >
            {children}
          </Box>
        </Box>
      </Box>
    </div>
  );
};
export default SelfDIrectedInvestMoreWrapper;
